import React, {memo, useCallback} from 'react';
import PropTypes from 'prop-types';
import {Select, Tag} from 'antd';
import {map} from 'lodash';
import {useTranslation} from 'react-i18next';

const {Option} = Select;

const SelectUserLabDataAccess = ({value, onChange, translation, ...props}) => {

  /*const currentValue = useMemo(() => {
    return Array.isArray(value) ? value.map(v => v?._id || v) : undefined;
  }, [value]);*/

  return (
    <Select
      mode="multiple"
      className="w-full"
      onChange={onChange}
      placeholder={translation('placeholderLabDataAccessSelect')}
      onClear={onChange}
      allowClear
      value={value}
      props={props}
    >
      <Option value="labDataFood">{translation('labDataFood')}</Option>
      <Option value="labDataLegionella">{translation('labDataLegionella')}</Option>
      <Option value="labDataPool">{translation('labDataPool')}</Option>
      <Option value="labDataOthers">{translation('labDataOthers')}</Option>
    </Select>
  );
};

SelectUserLabDataAccess.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  filters: PropTypes.object,
  isViewMode: PropTypes.func,
  translation: PropTypes.func,
  defaultValue: PropTypes.array,
};

// eslint-disable-next-line no-unused-vars
const SelectUserLabDataAccessView = ({value, entity}) => {
  const { t } = useTranslation('users');
  const tagsRender = useCallback((value) => {
    return (<div className='flex flex-wrap'>
      {map(value, (item) => (
        <div key={item} className="pb-2">
          <Tag className="px-2 py-1">
            {t(item)}
          </Tag>
        </div>
      ))}
    </div>);
  }, [t]);

  return (
    <>
      {tagsRender(value || [])}
    </>
  );
};

SelectUserLabDataAccessView.propTypes = {
  value: PropTypes.string,
  entity: PropTypes.object,
};

export default memo(SelectUserLabDataAccess);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {object} entity this is entity type
 * */
export const renderLabDataAccess = (text, entity) => {
  return (
    <SelectUserLabDataAccessView value={text} entity={entity}/>
  );
};

